const createShootingAwardReq = (name) => [
  {
    id: `000-${name}`,
    optional: 'False',
    number: '',
    name: 'Note: To complete this award, the scout should complete '
    + `Shooting Sports Emblem ${name} Level 1 requirement`,
    listNumber: '',
    sortOrder: '1',
    footer: '',
    childrenRequired: '',
    required: 'false',
    parentRequirementId: '',
    totalMBRequired: '',
    linkedAdventureRequirementId: '',
    linkedAdventureId: '',
    linkedMeritBadgeId: ''
  },
  {
    id: `001-${name}`,
    optional: 'False',
    number: '',
    name: `Complete the Level 1 and Level 2 requirements for ${name}`,
    listNumber: '1',
    status: 'NOT_STARTED',
    sortOrder: '2',
    footer: '',
    childrenRequired: '',
    required: 'True',
    parentRequirementId: '',
    totalMBRequired: '',
    linkedAdventureRequirementId: '',
    linkedAdventureId: '',
    linkedMeritBadgeId: ''
  }
];

const archeryReq = createShootingAwardReq('archery');
const bbGunReq = createShootingAwardReq('BB Gun shooting');
const slingshotReq = createShootingAwardReq('slingshot');

const hardcodedMap = {
  3376: {
    linkedReqId: '3174',
    linkedAward: '3375',
    req: archeryReq
  },
  3377: {
    linkedReqId: '3175',
    linkedAward: '3375',
    req: bbGunReq
  },
  3378: {
    linkedReqId: '3176',
    linkedAward: '3375',
    req: slingshotReq
  },
  3380: {
    linkedReqId: '3178',
    linkedAward: '3379',
    req: archeryReq
  }, // Wolf shooting awards
  3381: {
    linkedReqId: '3179',
    linkedAward: '3379',
    req: bbGunReq
  },
  3382: {
    linkedReqId: '3180',
    linkedAward: '3379',
    req: slingshotReq
  },
  3384: {
    linkedReqId: '3182',
    linkedAward: '3383',
    req: archeryReq
  }, // Bear shooting awards
  3385: {
    linkedReqId: '3183',
    linkedAward: '3383',
    req: bbGunReq
  },
  3386: {
    linkedReqId: '3184',
    linkedAward: '3383',
    req: slingshotReq
  },
  3388: {
    linkedReqId: '3186',
    linkedAward: '3387',
    req: archeryReq
  }, // Webelos shooting awards
  3389: {
    linkedReqId: '3187',
    linkedAward: '3387',
    req: bbGunReq
  },
  3390: {
    linkedReqId: '3188',
    linkedAward: '3387', // MAIN Shooting Sports Award - Webelos
    req: slingshotReq
  },
  /**
   * Shape of:
   * [relatedAwardId: number] {
   *    linkedReqId: string; // linked req in parent award
   *    linkedAwardId: string; // parent award
   * }
   */
  3691: { // Shooting Sports Pin - Lion Archery
    linkedReqId: '',
    linkedAward: '3690', // MAIN Shooting Sports Award - Lion,
    req: archeryReq
  },
  3692: { // Shooting Sports Pin - Lion Slingshot
    linkedReqId: '',
    linkedAward: '3690', // MAIN Shooting Sports Award - Lion
    req: slingshotReq
  }
};

const blockUpdate = {
  3174: {
    id: '3376',
    reqName: 'Level 1 Archery'
  },
  3175: {
    id: '3377',
    reqName: 'Level 1 BB Gun'
  },
  3176: {
    id: '3378',
    reqName: 'Level 1 Slingshot'
  },
  3178: {
    id: '3380',
    reqName: 'Level 1 Archery'
  },
  3179: {
    id: '3381',
    reqName: 'Level 1 BB Gun'
  },
  3180: {
    id: '3382',
    reqName: 'Level 1 Slingshot'
  },
  3182: {
    id: '3384',
    reqName: 'Level 1 Archery'
  },
  3183: {
    id: '3385',
    reqName: 'Level 1 BB Gun'
  },
  3184: {
    id: '3386',
    reqName: 'Level 1 Slingshot'
  },
  3186: {
    id: '3388',
    reqName: 'Level 1 Archery'
  },
  3187: {
    id: '3389',
    reqName: 'Level 1 BB Gun'
  },
  3188: {
    id: '3390',
    reqName: 'Level 1 Slingshot'
  },
  // this can be grabbed by calling
  // GET /advancements/parentAwardId/requirements
  //    [requirementId: number]: {
  //      id: string, // sub award id
  //      reqName: string // req name
  // }
  // Lion Awards
  /**
      3690 Shooting Sports Award - Lion
      3691 Shooting Sports Pin - Lion Archery
      3692 Shooting Sports Pin - Lion Slingshot
   */
  5610: { //       "name": "Level 1 Archery OR"
    id: '3691',
    reqName: 'Level 1 Archery'
  },
  5611: { //       "name": ""Level 1 Slingshot OR"
    id: '3692',
    reqName: '"Level 1 Slingshot'
  }
};

export {
  hardcodedMap,
  blockUpdate
};
